import { datatable } from '@/translations/pl/common/datatable'
import { errors } from '@/translations/pl/common/errors'
import { file } from '@/translations/pl/common/file'
import { menu } from '@/translations/pl/common/menu'
import { route } from '@/translations/pl/common/route' //skip-export

export const common = {
  add: 'Dodaj',
  select: 'Wybierz',
  submit: 'Zatwierdź',
  notFound: 'Nie znaleziono strony',
  notFoundResult: 'Nie znaleziono wyników',
  redirect: 'Przekierowywanie...',
  success: 'Sukces',
  error: 'Błąd',
  invalidOrExpiredToken: 'Sesja wygasła. Zaloguj się ponownie',
  edit: 'Edytuj',
  delete: 'Usuń',
  unknownError: 'Wystąpił nieznany błąd',
  save: 'Zapisz',
  confirm: 'Potwierdź',
  search: 'Wyszukaj',
  filter: 'Filtruj',
  darkTheme: 'Włącz ciemny motyw',
  lightTheme: 'Włącz jasny motyw',
  validFrom: 'Ważne od',
  label: 'Etykieta',
  description: 'Opis',
  code: 'Kod',
  cancel: 'Anuluj',
  restore: 'Przywróć',
  saveSuccess: 'Pomyślnie zapisano zmiany',
  deleteSuccessGroup: 'Poprawnie usunięto grupę',
  color: 'Kolor',
  yes: 'Tak',
  no: 'Nie',
  all: 'Wszystkie',
  create: 'Utwórz',
  sizes: 'Wymiary',
  length: 'Długość',
  height: 'Wysokość',
  width: 'Szerokość',
  to: 'do',
  loading: 'Ładowanie',
  noItems: 'Brak danych',
  clearSelection: 'Wyczyść',
  saveChanges: 'Zapisz zmiany',
  expand: 'Rozwiń',
  collapse: 'Zwiń',
  name: 'Nazwa',
  close: 'Zamknij',
  count: 'Wartość',
  back: 'Wróć',
  errors: errors,
  menu: menu,
  file: file,
  datatable: datatable,
  route,
}
